import { useEffect, useState } from 'react'
import { Container } from './styles'

type ModalComponentProps = {
  show: boolean
  children: JSX.Element
}

export const ModalComponent = ({ show, children }: ModalComponentProps) => {
  const [hasUpdate, setHasUpdate] = useState(false)

  useEffect(() => {
    if (show) {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
      setHasUpdate(true)
    }

    return () => {
      if (hasUpdate) {
        document.getElementsByTagName('html')[0].style.overflowY = 'scroll'
        setHasUpdate(false)
      }
    }
  }, [show, hasUpdate])

  return <Container show={show}>{children}</Container>
}
